import React, { useEffect, useState, useMemo } from "react";
import { Chip, Grid, Button } from "@mui/material";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import imageList from "../imageList.json";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
// import DownloadIcon from "@mui/icons-material/Download";
// import DownloadIcon from "@mui/icons-material/CloudDownload";
import { FiDownload as DownloadIcon } from "react-icons/fi";
import { HiOutlineShare as ShareIcon } from "react-icons/hi2";
import { IoClose as CloseIcon } from "react-icons/io5";

// import ShareIcon from "@mui/icons-material/Share";
import SlidingChips from "./SlidingChips";
import SlidingChipsMobile from "./SlidingChipsMobile";

const ImageGalleryComponent = ({
  flattenedImageList,
  selectedCountries,
  selectedSubfolders,
  subfolders,
  toggleSelection,
  countries,
  theme,
  isMobile,
  bigScreen,
  hasWomenFilter,
  setHasWomenFilter,
  toggleHasWomenFilter,
}) => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [openGallery, setOpenGallery] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);

  const [showFilters, setShowFilters] = useState(true);
  const [chipIndex, setChipIndex] = useState(0);

  const shuffleArray = (array) => {
    return array
      .map((value) => ({ value, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);
  };
  const filteredImages = useMemo(() => {
    let images = flattenedImageList;

    if (hasWomenFilter) {
      images = images.filter((image) => image.has_women === true);
    }

    if (!hasWomenFilter) {
      images = images.filter((image) => {
        const matchesCountry =
          selectedCountries.length === 0 ||
          selectedCountries.includes(image.country);
        const matchesSubfolder =
          selectedSubfolders.length === 0 ||
          selectedSubfolders.includes(image.subfolder);
        return matchesCountry && matchesSubfolder;
      });
    }

    return shuffleArray(images);
  }, [selectedCountries, selectedSubfolders, hasWomenFilter]);

  const clearAllSelections = () => {
    toggleSelection("country", null, true);
    toggleSelection("subfolder", null, true);
    setHasWomenFilter(false);
  };

  const handleDownload = (src) => {
    const link = document.createElement("a");
    link.href = src;
    link.download = src.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleShare = (src) => {
    if (navigator.share) {
      navigator
        .share({
          title: "Check out this image",
          url: src,
        })
        .catch((error) => console.log("Error sharing:", error));
    } else {
      alert("Sharing not supported on this browser.");
    }
  };

  const handleImageClick = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  const handlePrev = () => {
    setChipIndex((prev) => Math.max(prev - 1, 0));
  };

  const bgColor = theme === "light" ? "white" : "#121212";

  const chipBgColor =
    theme === "light" ? "rgba(250, 212, 198, 0.75)" : "transparent";

  const textColor = theme === "light" ? "black" : "white";

  return (
    <div
      style={{
        backgroundColor: bgColor,
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <h1 className="header-gallery">Gallery</h1>
      <p className="para-gallery">
        This collection brings together rich imagery from DiFi for All fieldwork
        across Bangladesh, India, Indonesia, and Uganda. It captures the
        settings, tools, and interactions where digital meets real financial
        lives — in markets, homes, shops, and transit hubs.You are welcome to
        share or use these images for non-commercial use, provided that clear
        credit is given to DiFi for All as follows: <br />
        DiFi for All (2025). Open-access resource on digital financial
        inclusion. Licensed under CC BY-NC-SA 4.0.
        <br />
        <a style={{ color: "#F2F2F2" }} href="https://dififorall.design">
          https://dififorall.design
        </a>
      </p>

      {isMobile || bigScreen ? (
        <SlidingChipsMobile
          countries={countries}
          subfolders={subfolders}
          selectedCountries={selectedCountries}
          selectedSubfolders={selectedSubfolders}
          toggleSelection={toggleSelection}
          bgColor={bgColor}
          textColor={textColor}
          bigScreen={bigScreen}
          isMobile={isMobile}
          chipBgColor={chipBgColor}
          hasWomenFilter={hasWomenFilter}
          setHasWomenFilter={setHasWomenFilter}
          toggleHasWomenFilter={toggleHasWomenFilter}
        />
      ) : (
        <SlidingChips
          countries={countries}
          subfolders={subfolders}
          selectedCountries={selectedCountries}
          selectedSubfolders={selectedSubfolders}
          toggleSelection={toggleSelection}
          bgColor={bgColor}
          textColor={textColor}
          chipBgColor={chipBgColor}
          hasWomenFilter={hasWomenFilter}
          setHasWomenFilter={setHasWomenFilter}
          toggleHasWomenFilter={toggleHasWomenFilter}
        />
      )}

      {(selectedSubfolders.length > 0 ||
        selectedCountries.length > 0 ||
        hasWomenFilter) && (
        <Button
          variant="contained"
          onClick={clearAllSelections}
          style={{
            position: "fixed",
            bottom: "70px",
            color: "black",
            right: "20px",
            zIndex: 1000,
            background: "#D9D9D9",
            fontSize: "9px",
          }}
        >
          Clear All
        </Button>
      )}

      <Grid container spacing={2}>
        {filteredImages.map((image, index) => (
          <Grid item xs={12} sm={6} md={3} key={image.thumbnail}>
            <img
              key={index}
              src={image.thumbnail}
              alt={image.thumbnail}
              loading="lazy"
              className="zoom-image"
              style={{
                width: "100%",
                height: "340px",
                objectFit: "cover",
                borderRadius: "8px",
                cursor: "pointer",
                boxShadow: "0 4px 6px rgba(255, 255, 255, 0.1)",
              }}
              onClick={() => handleImageClick(index)}
            />
          </Grid>
        ))}
      </Grid>
      <Lightbox
        slides={filteredImages.map((img) => ({ src: img.original }))}
        open={lightboxOpen}
        index={lightboxIndex}
        close={() => setLightboxOpen(false)}
        render={{
          buttonClose: () => null,
          slide: ({ slide }) => (
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={slide.src}
                alt=""
                style={{
                  maxWidth: "100%",
                  maxHeight: "90vh",
                  display: "block",
                  margin: "auto",
                }}
              />

              <div
                style={{
                  position: "absolute",
                  top: "0",
                  right: "0",
                  display: "flex",
                  gap: "15px",
                  zIndex: 1,
                }}
              >
                <DownloadIcon
                  style={{
                    color: "hsl(0deg 0% 100% / 80%)",
                    fontSize: "1.3rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handleDownload(slide.src)}
                />

                <ShareIcon
                  style={{
                    color: "hsl(0deg 0% 100% / 80%)",
                    fontSize: "1.3rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handleShare(slide.src)}
                />
                <CloseIcon
                  style={{
                    color: "hsl(0deg 0% 100% / 80%)",
                    marginTop: "-0.15rem",
                    fontSize: "1.8rem",
                    cursor: "pointer",
                  }}
                  onClick={() => setLightboxOpen(false)}
                />
              </div>
            </div>
          ),
        }}
      />
    </div>
  );
};

export default ImageGalleryComponent;
